import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Nest = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M11.5 12.5L14.5 9.5L11.5 6.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 3.5V5.5C1.5 6.56087 1.92143 7.57828 2.67157 8.32843C3.42172 9.07857 4.43913 9.5 5.5 9.5H14.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
